import { RouterModule, Routes } from '@angular/router';

import { AccountGuard } from '../core/account.guard';
import { LoginComponent } from './login.component';
import { canActivatePortal } from '../core/can-activate-portal';

const routes: Routes = [{
  path: 'login',
  component: LoginComponent,
  canActivate: [AccountGuard, canActivatePortal]
}];

export const LoginRoutingModule = RouterModule.forChild(routes);
